/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Footer, Header, Programs } from '../components';

const Masthead = ({ settings }) => {
	return (
		<>
			<Helmet>
				<title>Künye | Radyospor - Türkiye'nin İlk Spor Radyosu</title>
			</Helmet>

			<Header />

			<div className="container">
				<main className="masthead">
					<div className="row">
						<div className="col-lg-12">
							<div className="section-title">Künye</div>

							<div className="masthead-content">
								<ul>
									<li>
										<span>RADYOSPOR RADYO YAYINCILIĞI A.Ş.</span>
									</li>

									<li>
										<span>Medya Hizmet Sağlayıcı Kuruluş Kimlik Bilgisi</span>
									</li>

									<li>
										<span>Şirket Bilgileri:</span>
									</li>
									<li>
										<span>Ünvanı: </span>
										<span>Radyospor Radyo Yayıncılığı A.Ş.</span>
									</li>
									<li>
										<span>Logo/Çağrı İşareti: </span>
										<span>Radyo Spor</span>
									</li>
									<li>
										<span>Lisans Tipi: </span>
										<span>Uydu RD, Karasal RD, İnternet RD</span>
									</li>
									<li>
										<span>Yayın Adı: </span>
										<span>https://www.radyospor.com/</span>
									</li>
									<li>
										<span>Lisans Türü: </span>
										<span>Tematik (Müzik-eğlence)</span>
									</li>
									<li>
										<span>Yer Sağlayıcı: </span>
										<span>Contabo GmbH</span>
									</li>
									<li>
										<span>Yer Sağlayıcı Adres: </span>
										<span>Aschauer Straße 32a, 81549 Munich/Germany</span>
									</li>
									<li>
										<span>Yer Sağlayıcı Telefon ve Elektronik Posta Adresi: </span>
										<span>+49 (89) 3564717-71 support@contabo.com</span>
									</li>
									<li>
										<span>Yönetim Yeri: </span>
										<span>İSTANBUL</span>
									</li>
									<li>
										<span>Yazışma Adresi: </span>
										<span>PTT Evleri Mahallesi, Hacıosman Bayırı Caddesi, No:16, 34453, Sarıyer / İstanbul</span>
									</li>
									<li>
										<span>Telefon ve Faks: </span>
										<span>0 212 363 04 04 - 0 212 363 04 00</span>
									</li>
									<li>
										<span>Kurumsal E-Posta: </span>
										<span>info@radyospor.com</span>
									</li>
									<li>
										<span>Ulusal Elektronik Tebligat Sistemi Adresi: </span>
										<span>25999-86147-39589</span>
									</li>
									<li>
										<span>İnternet Adresi: </span>
										<span>https://www.radyospor.com/</span>
									</li>
									<li>
										<span>KEP Adresi: </span>
										<span>radyospor@hs03.kep.tr</span>
									</li>
									<li>
										<span>Genel Müdür: </span>
										<span>BARIŞ ERTÜL</span>
									</li>
									<li>
										<span>Posta Adresi: </span>
										<span>PTT Evleri Mahallesi, Hacıosman Bayırı Caddesi, No:16, 34453, Sarıyer / İstanbul</span>
									</li>
									<li>
										<span>Telefon ve Faks: </span>
										<span>0 212 363 04 04 – 0 212 363 04 00</span>
									</li>
									<li>
										<span>E-posta Adresi: </span>
										<span>baris.ertul@radyospor.com</span>
									</li>

									<li>
										<span>Sorumlu Müdür: </span>
										<span>ALİ ERİM</span>
									</li>
									<li>
										<span>Posta Adresi: </span>
										<span>PTT Evleri Mahallesi, Hacıosman Bayırı Caddesi, No:16, 34453, Sarıyer / İstanbul</span>
									</li>
									<li>
										<span>Telefon ve Faks: </span>
										<span>0 212 363 04 04 – 0 212 363 04 00</span>
									</li>
									<li>
										<span>E-posta Adresi: </span>
										<span>ali.erim@radyospor.com</span>
									</li>

									<li>
										<span>İzleyici Temsilcisi: </span>
										<span>MUSTAFA KIYICIOĞLU</span>
									</li>
									<li>
										<span>Posta Adresi: </span>
										<span>PTT Evleri Mahallesi, Hacıosman Bayırı Caddesi, No:16, 34453, Sarıyer / İstanbul</span>
									</li>
									<li>
										<span>Telefon ve Faks: </span>
										<span>0 212 363 04 04 – 0 212 363 04 00</span>
									</li>
									<li>
										<span>E-posta Adresi: </span>
										<span>mustafa.kiyicioglu@saran.com.tr</span>
									</li>
								</ul>
							</div>
						</div>
					</div>

					<Programs />
				</main>
			</div>

			<Footer />
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		settings: state.Settings.settings,
	};
};

export default connect(mapStateToProps)(Masthead);
